import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function PostListTemplate({ post, type = "posts" }) {
	const [image, setImage] = useState(post?.fimg_url);

	useEffect(() => {
		console.log(post);
	}, [post]);

	return (
		<div className="col-md-6 col-lg-4 my-3">
			<div className="card">
				<img src={image} alt="" className="img-fluid" />

				<div className="card-body">
					<h2>
						<Link to={`/${type}/${post?.id}`}>
							{post?.title?.rendered}
						</Link>
					</h2>
				</div>
			</div>
		</div>
	);
}
export default PostListTemplate;
